import React, { useEffect, useState } from "react";

import { ADMINVERSION } from "../utils/info";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuFlag from "./menu/MenuFlag";
import MenuIcon from "@mui/icons-material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MuiAppBar from "@mui/material/AppBar";
import ProfileDropdownMenu from "./menu/ProfileDropdownMenu";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { navbarStyles } from "../../assets/styles/navbarStyles";
import { styled } from "@mui/material/styles";
import { useLocation } from "react-router-dom";

const TopNavbar = ({ drawerWidth, setOpen, open, handleDrawerOpen }) => {
  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  const location = useLocation();

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const [titleApp, setTitleApp] = useState("Inicio");
  useEffect(() => {
    switch (location.pathname) {
      case "/home":
        setTitleApp("Inicio");
        break;
      case "/items":
        setTitleApp("Contenido Home");
        break;
      case "/services":
        setTitleApp("Videos Home");
        break;
      case "/synthetics":
        setTitleApp("Sintéticos");
        break;
      case "/cryptos":
        setTitleApp("Cryptos");
        break;
      case "/forex":
        setTitleApp("Forex");
        break;
      case "/community":
        setTitleApp("Comunidad");
        break;
      case "/academy":
        setTitleApp("Banners Academia");
        break;
      case "/notifications":
        setTitleApp("Notificaciones");
        break;

      case "/schedules":
        setTitleApp("Agenda");
        break;
      case "/schedules/sessions":
        setTitleApp("Sesiones");
        break;
      case "/schedules/masterclass":
        setTitleApp("Masterclass");
        break;
      case "/users":
        setTitleApp("Usuarios");
        break;
      case "/admins":
        setTitleApp("Administradores");
        break;
      case "/plans":
        setTitleApp("Planes");
        break;
      case "/reviews":
        setTitleApp("Reseñas");
        break;
      case "/home-config":
        setTitleApp("Banners Inicio");
        break;

      case "/signals":
        setTitleApp("Señales");
        break;

      default:
        setTitleApp("Inicio");
        break;
    }
  }, [location, setTitleApp]);

  return (
    <AppBar
      position="fixed"
      open={open}
      sx={{
        minHeight: 72,
        background: "rgba(8, 6, 14, 0.92)",
        backdropFilter: "blur(18px)",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
      }}
    >
      <Container maxWidth={false} sx={{ px: { xs: 2, md: 3 } }}>
        <Toolbar disableGutters sx={{ minHeight: "72px !important" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              mr: 2,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>

          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              color: "text.primary",
              fontSize: 20,
              fontWeight: 800,
              letterSpacing: 0.2,
            }}
          >
            {titleApp}
          </Typography>

          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "none" },
              color: "text.primary",
              fontSize: 18,
              fontWeight: 800,
            }}
          >
            {titleApp}
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}></Box>
          <Box sx={{ flexGrow: 0, marginLeft: "auto" }}>
            {/* <MenuFlag/>  */}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexGrow: 0,
              marginLeft: "auto",
              flexDirection: "row",
            }}
          >
            <Box mr={2}>
              <Typography
                variant="caption"
                sx={{
                  color: "text.secondary",
                  fontWeight: 700,
                  letterSpacing: 0.6,
                }}
              >
                {ADMINVERSION}
              </Typography>
            </Box>
            <ProfileDropdownMenu />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default TopNavbar;
